import React from 'react';
import { KatAccordion } from '@amzn/katal-react';
import { LearningPathwaySection } from 'src/types/state/learningPathway';
import ModuleSectionItem from './ModuleSectionItem';

/**
 * Props interface for the LearningPathwayAccordion component
 */
interface LearningPathwayAccordionProps {
  sections: LearningPathwaySection[];
  onModuleSelect: (moduleId: string) => void;
  isLocalized?: boolean;
}

/**
 * LearningPathwayAccordion Component
 *
 * Renders an accordion view for displaying learning pathway sections and their modules.
 * Each section can be expanded to show its modules, and each module can be selected.
 * The component handles the display of progress indicators for both sections and modules.
 */
const LearningPathwayAccordion: React.FC<LearningPathwayAccordionProps> = ({
  sections,
  onModuleSelect,
  isLocalized = false,
}) => {
  return (
    <KatAccordion className="mx-auto w-full">
      {sections.map((section, index) => (
        <ModuleSectionItem
          key={section.sectionId}
          section={section}
          index={index}
          onModuleSelect={onModuleSelect}
          expanded={index === 0} // Expand the first section when page loads
          isLocalized={isLocalized}
        />
      ))}
    </KatAccordion>
  );
};

export default LearningPathwayAccordion;
